<template>
  <div>
    <b-breadcrumb :items="items"></b-breadcrumb>
    <div class="row mx-0 mb-3">
      <div class="col-lg-12">
        <b-card
          title="Bon de commande"
          class="bg-light shadow"
          title-tag="h6"
        >
        <form class="mx-2" name="bonForm" id="form_bon_de_commande">
          <b-row>
            <b-col lg="6">
              <b-row>
                <mh-input
                  mhClass="col-6"
                  :table="table"
                  field="company"
                ></mh-input>
                <mh-input
                  mhClass="col-6"
                  :table="table"
                  field="mobile"
                ></mh-input>
                <mh-input
                  mhClass="col-6"
                  :table="table"
                  field="contact"
                ></mh-input>
                <mh-input
                  mhClass="col-6"
                  :table="table"
                  field="phone"
                ></mh-input>
                <mh-input
                  mhClass="col-6"
                  :table="table"
                  field="address"
                ></mh-input>
                <mh-input mhClass="col-6" :table="table" field="fax"></mh-input>
                <mh-input mhClass="col-6" :table="table" field="cp"></mh-input>
                <mh-input
                  mhClass="col-6"
                  :table="table"
                  field="mail"
                ></mh-input>
                <mh-input mhClass="col-6" :table="table" field="vat"></mh-input>
                <mh-input mhClass="col-6" :table="table" field="url"></mh-input>
                <mh-input
                  mhClass="col-6"
                  :table="table"
                  field="login"
                ></mh-input>
                <mh-input
                  mhClass="col-6"
                  :table="table"
                  field="password"
                ></mh-input>
                <mh-input
                  mhClass="col-6"
                  :table="table"
                  field="payment"
                ></mh-input>
                <mh-input
                  mhClass="col-6"
                  :table="table"
                  field="account"
                ></mh-input>
              </b-row>
            </b-col>
            <b-col lg="6">
              <b-row>
                <mh-input
                  mhClass="col-6"
                  :table="table"
                  field="numberWarrants"
                  @update="adaptUnitPrice()"
                ></mh-input>
                <mh-input
                  mhClass="col-6"
                  :table="table"
                  field="unitPriceWarrant"
                  append="€"
                ></mh-input>

                <b-col lg="6" offset="6" class="mt-4">
                  <div class="total">
                    <p>
                      Total achat de mandats :
                      <span class="float-right"
                        >{{ twoDigits(totalHTVA) }} €</span
                      >
                    </p>

                    <p>
                      TVA :
                      <span class="float-right"
                        >{{ twoDigits(totalHT) }} €</span
                      >
                    </p>
                    <p>
                      Total TTC :
                      <span class="float-right"
                        >{{ twoDigits(totalTTC) }} €</span
                      >
                    </p>
                  </div>
                </b-col>
                <div class="col-12 text-right mt-3">
                  <b-button @click="refresh" variant="success"
                    >Créer le bon de commande</b-button
                  >
                  <b-button
                    v-if="pdfPath && table.mail.value"
                    @click="sendPurchaseOrder()"
                    class="ml-3"
                  >
                    Envoyer le bon de commande
                  </b-button>
                </div>
              </b-row>
            </b-col>
          </b-row>
        </form>
        </b-card>
      </div>
      <div class="col-lg-12" v-if="pdfPath">
        <object
          class="mt-4"
          v-if="pdfPath"
          style="width: 100%; height: 1000px"
          :data="pdfPath"
          type="application/pdf"
        ></object>
      </div>
    </div>
  </div>
</template>

<script>
import DateTime from "@/services/DateTime.js";
import creditors from "@/services/creditors.js";
import MhInput from "@/components/MhInput.vue";

export default {
  name: "purchase-order",
  components: {
    MhInput,
  },
  props: {},
  data() {
    return {
      pdfPath: null,
      items: [
        {
          text: "Gestion",
          to: { name: "home" },
        },
        {
          text: "Créanciers",
          to: { name: "creditors" },
        },
        {
          text: "Création d'un bon de commande",
          active: true,
        },
      ],
      table: {
        company: {
          label: "Firme",
          type: "varchar",
          value: "",
        },
        contact: {
          label: "Contact",
          type: "varchar",
          value: "",
        },
        address: {
          label: "Adresse",
          type: "varchar",
          value: "",
        },
        cp: {
          label: "CP / Ville",
          type: "varchar",
          value: "",
        },
        vat: {
          label: "Numéro d'entreprise",
          type: "varchar",
          value: "",
        },
        mobile: {
          label: "GSM",
          type: "varchar",
          value: "",
        },
        phone: {
          label: "Téléphone",
          type: "varchar",
          value: "",
        },
        fax: {
          label: "Fax",
          type: "varchar",
          value: "",
        },
        mail: {
          label: "Email",
          type: "email",
          value: "",
        },
        url: {
          label: "URL",
          type: "url",
          value: "",
        },
        login: {
          label: "Login",
          type: "varchar",
          value: "",
        },
        password: {
          label: "Mot de passe",
          type: "varchar",
          value: "",
        },
        payment: {
          label: "Paiement",
          options: [
            {
              value: "comptant",
              text: "Comptant",
            },
            {
              value: "virement bancaire",
              text: "Virement bancaire",
            },
            {
              value: "bancontact",
              text: "Bancontact",
            },
          ],
          value: "virement bancaire",
        },
        account: {
          label: "Restitution sur le n° de compte",
          type: "varchar",
          value: "",
        },
        numberWarrants: {
          label: "Nombre de mandats",
          type: "int",
          value: 10,
        },

        unitPriceWarrant: {
          label: "Prix unitaire",
          type: "float",
          value: 35,
        },
      },
    };
  },
  created() {},
  computed: {
    totalHTVA() {
      return (
        this.table.unitPriceWarrant.value * this.table.numberWarrants.value
      );
    },

    totalHT() {
      return this.totalHTVA * 0.21;
    },
    totalTTC() {
      return this.totalHTVA + this.totalHT;
    },
  },
  methods: {
    sendPurchaseOrder() {
      if (this.table.mail.value) {
        creditors.send_purchase_order(this.table).then((response) => {
          if (response.data.success) {
            this.$bvToast.toast(response.data.message, {
              title: `Recuperator`,
              toaster: "b-toaster-top-right",
              variant: "success",
              autoHideDelay: 2000,
              solid: false,
            });
          }
        });
      }
    },
    adaptUnitPrice() {
      if (this.table.numberWarrants.value <= 10) {
        this.table.unitPriceWarrant.value = 35;
      } else if (this.table.numberWarrants.value <= 20) {
        this.table.unitPriceWarrant.value = 30;
      } else if (this.table.numberWarrants.value <= 30) {
        this.table.unitPriceWarrant.value = 25;
      } else if (this.table.numberWarrants.value <= 50) {
        this.table.unitPriceWarrant.value = 20;
      } else {
        this.table.unitPriceWarrant.value = 15;
      }
    },
    
    refresh() {
      let el = document.querySelector("#form_bon_de_commande");
      if (!el) {
        return "";
      }
      const formData = new FormData(el);
      let data = {};
      for (var pair of formData.entries()) {
        data[pair[0]] = pair[1];
      }
      creditors
        .getPurchaseOrderPreviewPDF(data)
        .then((response) => {
          this.pdfPath = "data:application/pdf;base64," + response.data + "#zoom=100";
        });
    },
    toDate(d) {
      return DateTime.humanDate(d);
    },
    twoDigits(value) {
      return Number(value).toFixed(2);
    },
  },
};
</script>

<style lang="scss" scoped>
.total {
  //background-color: rgb(158, 158, 158);
  padding: 10px 10px 1px 10px;
  border-radius:5px;
  border: 1px solid black;
  p span {
    font-weight: bolder;
  }
}
</style>